module.exports = __webpack_public_path__ + "img/cover4.f1ff45d4.jpeg";